import { ClientThemeConfig } from "../../types";
import demoLogo from "../../../assets/demo.png";

export const cadentTheme: ClientThemeConfig = {
  lightPalette: {
    mode: "light",
    primary: { main: "#E84B0F" },
  },
  darkPalette: {
    mode: "dark",
    primary: { main: "#F8863F" },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    button: { textTransform: "capitalize" },
  },
  branding: {
    appName: "Skewb Capital Delivery",
    platformName: "Project & Portfolio Platform",
    logoLight: demoLogo,
    logoDark: demoLogo,
    logoMaxWidth: "112px",
    logoMaxHeight: "30px",
  },
};
